const defaultQuery = {
  limit: 25,
  page: 1,
  sort: ['updatedAt:desc'],
}

export { defaultQuery }
